import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { Translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { deleteEntity, getEntity } from './gas-supply.reducer';

export const GasSupplyDeleteDialog = (props: RouteComponentProps<{ id: string; schedulingId: string }>) => {
  const dispatch = useAppDispatch();
  const updateSuccess = useAppSelector(state => state.gasSupply.updateSuccess);
  const gasSupplyEntity = useAppSelector(state => state.gasSupply.entity);

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    dispatch(deleteEntity({ id: gasSupplyEntity.id, schedulingId: props.match.params.schedulingId }));
  };

  const handleClose = () => {
    props.history.goBack();
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="gasSupplyDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="fleetSenseApp.gasSupply.delete.question">
        <Translate contentKey="fleetSenseApp.gasSupply.delete.question" interpolate={{ id: gasSupplyEntity.id }}>
          Are you sure you want to delete this GasSupply?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancelar</Translate>
        </Button>
        <Button id="app-confirm-delete-gasSupply" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Excluir</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default GasSupplyDeleteDialog;
